
import { Toast } from "vant";
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Logout extends Vue {
  @Prop({ default: {}, type: Object }) public detailList;

  public count = 0;
  public isLoading = false;
  public type: any = 2;
  public data: any = [];
  public mounted() {
    this.type = this.detailList.type;
    this.data.push(this.detailList.data);
  }
  // 重新提现
  public onExtractDialog() {
    this.$router.push({ name: "extract", params: { type: this.type } });
  }
  public onClickLeft() {
    this.$emit("confirmDetail", false);
  }
  public onRefresh() {
    setTimeout(() => {
      Toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 1000);
  }
}
